// @ts-nocheck
document.querySelectorAll('[data-section-reviews-custom]').forEach((section) => {
  // ── Swiper ──────────────────────────────────────────────────
  const swiperEl = section.querySelector('.section-reviews-custom__swiper');
  if (swiperEl && typeof Swiper !== 'undefined') {
    new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      navigation: {
        prevEl: section.querySelector('.section-reviews-custom__nav--prev'),
        nextEl: section.querySelector('.section-reviews-custom__nav--next'),
      },
      pagination: {
        el: swiperEl.querySelector('.section-reviews-custom__pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
      breakpoints: {
        750: { slidesPerView: 2, spaceBetween: 20 },
        990: { slidesPerView: 4, spaceBetween: 24 },
      },
    });
  }

  // ── Read-more toggle ────────────────────────────────────────
  section.querySelectorAll('[data-read-more]').forEach((btn) => {
    const textEl = document.getElementById(btn.getAttribute('aria-controls'));
    if (!textEl) return;

    // Show button only when text is actually clamped
    if (textEl.scrollHeight > textEl.clientHeight + 2) {
      btn.style.display = 'flex';
    }

    btn.addEventListener('click', () => {
      const willExpand = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(willExpand));
      textEl.classList.toggle('is-expanded', willExpand);
      btn.querySelector('.section-reviews-custom__read-more-text').textContent = willExpand
        ? 'Read less'
        : 'Read more';
    });
  });
});
